<template>
  <body class="signIn">
      <div class="text1">报名线上课堂</div>
      <div class="white">
      <!-- <div class="goBackOne" @click="$router.push('/signIn');refreshLocation();"></div> -->
    <!-- <div class="text2">2 / 2</div> -->
    <div class="text2" style="top: 80px;font-size: 20px;">请补充填写以下信息</div>
    <v-text-field
    class="area1"
    v-model="nameUser"
    placeholder=""
    label="姓名 *"
    outlined
    :rules="[rules.notNull]"
  ></v-text-field>
  <v-text-field
    class="area1"
    style="top: 261px;"
    v-model="companyUser"
    placeholder=""
    label="单位/机构 *"
    outlined
    :rules="[rules.notNull]"
  ></v-text-field>
  <v-select
  v-model="sexUser"
  class="area1"
  style="top: 330px;"
  :items="sexList"
  label="性别"
  placeholder=" "
  outlined
  :rules="[rules.notNull]"
></v-select>
<v-text-field
class="area1"
style="top: 399px;"
v-model="ageUser"
placeholder=""
label="年龄 *"
outlined
:rules="[rules.ageJudge]"
></v-text-field>
<v-select
class="area1"
style="top: 468px;"
v-model="educationUser"
placeholder=""
:items="educationList"
label="学历 *"
outlined
:rules="[rules.notNull]"
></v-select>
<v-text-field
class="area1"
style="top: 537px;"
v-model="majorUser"
placeholder=""
label="专业方向 *"
outlined
:rules="[rules.notNull]"
></v-text-field>
<v-text-field
class="area1"
style="top: 606px;"
v-model="emailUser"
placeholder=""
label="邮箱 *"
outlined
:rules="[rules.emialNumber]"
></v-text-field>
<div class="button" v-if="!signInPermit">申请报名</div>
<div class="button-s" v-if="signInPermit" @click="signInSuccess()">申请报名</div>
        </div>
  </body>
</template>
<script>
import {rootUrl} from '@/globalConfig'
  //   import $ from "jquery";
  export default {
    name: "signInContent",
    data() {
      return {
          nameUser: "",
          companyUser:"",
          sexUser:"",
          sexList:["男","女"],
          ageUser:"",
          educationUser:"",
          emailUser:"",
          majorUser:"",
          educationList:["高中","专科","本科","硕士研究生","博士研究生","博士后"],
          signInPermit:false,
          isOnLine:0,
          rules: {
      notNull: (value) => {
        if (value == "" || value == null) {
          return "此项不能为空";
        } else {
          return true;
        }
      },
      emialNumber: (value) => /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(value) || "邮箱不合法",
      ageJudge: (value) => {
          if(!isNaN(parseFloat(value)) && isFinite(value)){
              if(value>=0&&value<=100){
                  return true;
              }else{
                  return "年龄输入不合法";
              }
          }else{
              return "年龄输入不合法";
          }
        
      },
    },
      };
    },
    methods: {
      getKey() {
        return localStorage.getItem("token");
      },
      refreshLocation() {
        // location.reload();
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "instant",
        });
      },
      queryCourseRegisterStatus() {
          //判断当前状态
          this.axios
          .get("/learn_back/course/register/queryCourseRegisterStatus", { 
            headers: {
              Authorization: "Bearer " + this.getKey(),},
          })
          .then((res) => {
            console.log(res.data);
            if(this.isOnLine==1){
              let onlineStatus=res.data.data.onlineStatus
              if(this.$store.state.agentRepeat==0){
                if(onlineStatus!=0){
                  this.$router.push({path:'/signInResult',query:{'type':1}}); 
                }
              }
            }
          });
        
      },
      getRegisterCache(){
        this.axios.get("/learn_back/course/register/getRegisterCache", {
          headers: {
            Authorization: "Bearer " + this.getKey(),
          },
        })
        .then((res) => {
          if(res.data.data.name!=null&&res.data.data.name!=''){
            this.nameUser=res.data.data.name
          }
          if(res.data.data.company!=null&&res.data.data.company!=''){
            this.companyUser=res.data.data.company
          }
          if(res.data.data.sex!=null&&res.data.data.sex!=''){
            this.sexUser=res.data.data.sex
          }
          if(res.data.data.age!=null&&res.data.data.age!=''){
            this.ageUser=res.data.data.age
          }
          if(res.data.data.email!=null&&res.data.data.email!=''){
            this.emailUser=res.data.data.email
          }
          if(res.data.data.education!=null&&res.data.data.education!=''){
            this.educationUser=res.data.data.education
          }
          if(res.data.data.major!=null&&res.data.data.major!=''){
            this.majorUser=res.data.data.major
          }
        })
      },

      submitOk(){
          let myreg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
          if(this.nameUser!=null&&this.nameUser!=""&&this.companyUser!=null&&this.companyUser!=""
          &&this.sexUser!=null&&this.sexUser!=""
          &&this.ageUser!=null&&this.ageUser!=""
          &&this.educationUser!=null&&this.educationUser!=""
          &&this.emailUser!=null&&this.emailUser!=""
          &&myreg.test(this.emailUser)
          &&this.majorUser!=null&&this.majorUser!=""){
              this.signInPermit=true
          }else{
              this.signInPermit=false
          }
      },
      signInSuccess(){
          let sex = 0
          if(this.sexUser=="男"){
              sex=0
          }else if(this.sexUser=="女"){
              sex=1
          }
          var userInfo = {
                  "sex":sex,
                  "company":this.companyUser,
                  "age":this.ageUser,
                  "major":this.majorUser,
                  "education":this.educationUser,
                  "email":this.emailUser,
                  
              }
       if(this.isOnLine==2){
        this.axios
        .post(
          "/learn_back/course/register/saveBothCourseRegister",userInfo,
          {
            headers: {
              Authorization: "Bearer " + this.getKey(),
            },
          }
        )
        .then((res) => {
          let resData = res.data;
          console.log(resData);
          if (resData.msg != "success") {
            alert("提交失败");
          } else if (resData.msg == "success") {
              this.$store.state.agentRepeat=0
              this.$router.push({path:'/signInResult',query:{'type':2}})
              this.refreshLocation()
          }
        });
       }else if(this.isOnLine==1){
        this.axios
        .post(
          "/learn_back/course/register/saveOnlineCourseRegister",userInfo,
          {
            headers: {
              Authorization: "Bearer " + this.getKey(),
            },
          }
        )
        .then((res) => {
          let resData = res.data;
          if (resData.msg != "success") {
            alert("提交失败");
          } else if (resData.msg == "success") {
              this.$store.state.agentRepeat=0
              this.$router.push({path:'/signInResult',query:{'type':1}})
              this.refreshLocation()
          }
        });
       }      
      
      },
       //带权限判断的跳转
      jumpWithPermission(type,path,fromUrl){
        //path:需要跳转到的路由；fromUrl：如果权限不满足，满足后回跳的路由
        //注意：fromUrl必须为包含本项目router中base的相对地址，如商城个人中心为：/store/UserCenter
        let loginUserId=localStorage.getItem('userId');//是否已登录
        let authentication=localStorage.getItem('authentication');//0:已实名；1：未实名
        if(type=='可游客'){
          if(fromUrl){
            window.open(rootUrl+path+"?fromUrl="+rootUrl+fromUrl,"_self")
          }
          else {
            window.open(rootUrl+path,"_self")
          }
        }else if(type=='仅登录'){
          //已登录
          if(loginUserId){
            if(fromUrl){
              window.open(rootUrl+path+"?fromUrl="+rootUrl+fromUrl,"_self")
            }
            else {
              window.open(rootUrl+path,"_self")
            }
          }
          //未登录
          else {
            if(fromUrl){
              window.open(rootUrl+'/Login'+"?fromUrl="+rootUrl+fromUrl,"_self")
            }
            else {
              window.open(rootUrl+'/Login',"_self")
            }
          }
        }else if(type=='仅实名'){
          //已登录
          if(loginUserId){
            //已实名
            if(authentication=='0'){
              if(fromUrl){
                window.open(rootUrl+path+"?fromUrl="+rootUrl+fromUrl,"_self")
              }
              else {
                window.open(rootUrl+path,"_self")
              }
            }
            //未实名
            else {
              window.open(rootUrl+'/Authentication',"_self")
            }

          }
          //未登录
          else {

            if(fromUrl){
              window.open(rootUrl+'/Login'+"?fromUrl="+rootUrl+fromUrl,"_self")
            }
            else {
              window.open(rootUrl+'/Login',"_self")
            }
          }
        }
      },
       //实名权限检查与处理（培训班版）
      checkAndHandleAuthentication(){
          console.log("进入实名检查")
          let loginUserId=localStorage.getItem('userId');//是否已登录
          let authentication=localStorage.getItem('authentication');//0:已实名；1：未实名
          console.log(loginUserId,authentication)
          console.log(localStorage.getItem('preRoute'))
          if(!loginUserId){
            this.jumpWithPermission('仅登录','/Login','/learn/signInContent')
          }
          else if(authentication!='0'){
            this.jumpWithPermission('仅实名','/Authentication','/learn/signInContent')
        }
        return true;
      },
      jumpSignInContent(){
        if(this.checkAndHandleAuthentication()){
          this.$router.push({path:'/signInContent',query:{'type':1}});
          this.refreshLocation();
        }
      }

    },
  
    mounted() {
      this.isOnLine=this.$route.query.type;
      if (this.checkAndHandleAuthentication()) {
        this.queryCourseRegisterStatus()
        //提交按钮控制
        this.$nextTick(() => {
          setInterval(this.submitOk, 200);
        })
      }
      this.getRegisterCache()
    
    },
  };
</script>
<style scoped>
.signIn {
position: relative;
width: 100%;
height: 1430px;
background: #f5f5f6;
}
.text1 {
position: absolute;
top: 174px;
left: calc(50% - 640px);
width: 1280px;
height: 31px;
font-size: 26px;
font-family: Tensentype-ZhiHeiJ-W4, Tensentype-ZhiHeiJ;
font-weight: normal;
color: #3a3a3a;
line-height: 31px;
text-align: center;
}
.white {
position: absolute;
top: 259px;
left: calc(50% - 640px);
width: 1280px;
height: 850px;
background: #ffffff;
box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.05);
border-radius: 16px;
}
.goBackOne{
position: absolute;
top: 63px;
left: 565px;
width: 26px;
height: 26px;
background-image: url("~@/assets/Home/灰色返回.png");
background-size: 100% 100%;
cursor: pointer;
z-index: 1;
}
.goBackOne:hover{
background-image: url("~@/assets/Home/金色返回.png");
}
.text2 {
position: absolute;
top: 61px;
left: calc(50% - 150px);
width: 300px;
height: 30px;
font-size: 26px;
font-family: Arial-BoldMT, Arial;
font-weight: normal;
color: #979797;
line-height: 31px;
text-align: center;
}
.area1{
  position: absolute;
  top: 192px;
  left: calc(50% - 250px);
  width: 500px;
height: 50px;
background: rgba(0,0,0,0.05);
border-radius: 8px;
/* border: 1px solid rgba(0,0,0,0.25); */
}
.button{
  position: absolute;
  top: 730px;
  left: calc(50% - 75px);
  width: 150px;
height: 44px;
background: #cccccc;
border-radius: 22px;
font-size: 16px;
font-family: PingFangSC-Semibold, PingFang SC;
font-weight:500;
color: #FFFFFF;
line-height: 44px;
text-align: center;
}
.button-s{
  position: absolute;
  top: 730px;
  left: calc(50% - 75px);
  width: 150px;
height: 44px;
background: #C49760;
border-radius: 22px;
font-size: 16px;
font-family: PingFangSC-Semibold, PingFang SC;
font-weight:500;
color: #FFFFFF;
line-height: 44px;
text-align: center;
cursor: pointer;
}
</style>
<style scoped>
   ::v-deep.v-text-field--outlined > .v-input__control > .v-input__slot {
  align-items: stretch;
  min-height: 51px;
}
</style>
